export const selectIsOneAppUserAuthenticated = state =>
    Boolean(state.user.isOneAppAuthenticated);
